import axiosClient from "utils/axios";
import { ApiResponse } from "types/api.types";
import type { StockMovementType } from "../constants/stock-movement.constants";
import {
  CreateStockMovementRequest,
  StockMovement,
  StockMovementsTableResponse,
} from "../types/stock-movement.types";

/** Backend list shape: { data: rows, total, page, limit } */
type ListRaw = {
  data?: StockMovement[];
  rows?: StockMovement[];
  total?: number;
  page?: number;
  limit?: number;
};

export const getStockMovements = async ({
  page = 1,
  limit = 10,
  search: _search,
  productId,
  movementType,
  locationId,
}: {
  page?: number;
  limit?: number;
  search?: string;
  productId?: number;
  movementType?: StockMovementType;
  locationId?: number;
} = {}) => {
  const { data } = await axiosClient.get<ApiResponse<ListRaw>>(
    "/stock-movements",
    {
      params: {
        page,
        limit,
        productId: productId || undefined,
        movementType: movementType || undefined,
        locationId: locationId || undefined,
      },
    },
  );

  const inner = data.data;
  const rows = Array.isArray(inner?.data)
    ? inner.data
    : Array.isArray(inner?.rows)
      ? inner.rows
      : [];
  const totalItems =
    typeof inner?.total === "number" ? inner.total : rows.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / limit));

  return {
    success: data.success,
    message: data.message,
    data: {
      rows,
      totalItems,
      currentPage: page,
      pageSize: limit,
      limit,
      totalPages,
    },
  } satisfies ApiResponse<StockMovementsTableResponse>;
};

export const getStockMovement = async (id: number) => {
  const response = await axiosClient.get<ApiResponse<StockMovement>>(
    `/stock-movements/${id}`,
  );
  return response.data;
};

export const createStockMovement = async (
  payload: CreateStockMovementRequest,
) => {
  const response = await axiosClient.post<ApiResponse<StockMovement>>(
    "/stock-movements",
    payload,
  );
  return response.data;
};
